
import React from 'react';

export default () => (
  <div>
    <p>
      I enjoy learning all sorts of programming languages. My current favorite is Elixir.
      Elixir has this awesome web framework called Phoenix.
    </p>

    <p>
      Python is always good to have in your toolbox since it's ubiquitous.
    </p>

    <p>
      I learned Perl a long time ago. Just like Ruby, I like Perl for its expressiveness.
    </p>

    <p>
      I dabbled in Go here and there. This thing is weird but it's popular so I was
      intrigued enough to learn it.
    </p>

    <p>
      C and C++: two of the very first languages that I learned. Given C or C++ code to
      read or debug, I'm confident enough to say that I won't make the problem worse.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/stacks/more_info/OtherLanguages.js